<template>
  <v-app style="background: #f5f5f5">
    <AppHeader />
    <v-main>
      <v-container fluid> 
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </v-container>
    </v-main>

    <AppFooter />
  </v-app>
</template>

<script>
import AppHeader from "./components/Header/AppHeader";
import AppFooter from "./components/Footer/AppFooter";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      drawer: null,
    };
  },
};

</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>